<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div>
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <!-- <h5>OSS | O2Care - Oxygen Digital Shop</h5> -->
                            <button
                                class="btn btn-secondary align-right"
                                align="right"
                                onClick="window.print()"
                            >
                                <i class="fa fa-cog"></i>Print Outward Summary
                                Sheet
                            </button>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <div class="col-lg-12" id="element-to-convert">
                    <div
                        class="card"
                        style="
                            border: none !important;
                            border-radius: 30px !important;
                            margin-bottom: 10px !important;
                        "
                    >
                        <br />
                        <!-- main row for all icons  -->
                        <div class="col-lg-12" id="print">
                            <div class="col-sm-12">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <LogoPrint></LogoPrint>
                                    </div>
                                    <div class="col-sm-8" align="right">
                                        <h1>Outward Summary</h1>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <br />

                            <!-- action buttons end -->
                            <!-- job info summary card -->
                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="row">
                                            <div class="col-sm-5">
                                                <b>Job Category: </b><br />
                                                <b>Job No: </b><br />
                                                <b>Customer Name:</b><br />
                                                <b>Customer Phone:</b><br />
                                                <b>Assigned To: </b><br />
                                                <b>Job Added On:</b><br />
                                                <b>Job Added By:</b><br />
                                            </div>
                                            <div class="col-sm-7">
                                                {{ job.job_category }}<br />

                                                {{ job.job_no }}<br />

                                                {{ job.customer_name }}<br />

                                                {{ job.customer_numbers }}<br />

                                                {{ job.assigned_name }}<br />

                                                {{ job.created_at | timeStamp
                                                }}<br />
                                                {{ job.created_name }}<br />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 float-right">
                                        <div class="row">
                                            <div class="col-sm-5">
                                                <b>Branch: </b><br />
                                                <b>GST: </b><br />
                                                <b>Payment Status:</b><br />
                                                <b>Total Amount:</b><br />
                                                <b>Collected Amount: </b><br />
                                                <b>Pending Amount:</b><br />
                                            </div>
                                            <div class="col-sm-7">
                                                {{ job.branch }} |
                                                {{ job.branch_name }}<br />
                                                {{ job.branch_gst }}<br />
                                                {{ job.payment_status }}<br />
                                                {{ job.total_amount }}<br />
                                                {{ job.amount_collected }}<br />
                                                {{ job.amount_left }}<br />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- job info summary card end -->
                            <br />
                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <h5>Job Costs and Associated Fees</h5>
                                        <table
                                            class="table table-striped table-bordered table-hover"
                                        >
                                            <thead>
                                                <tr>
                                                    <th>Charge For</th>
                                                    <th>Sl. No.</th>
                                                    <th>Charge</th>
                                                    <th>Approved</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="r in amounts"
                                                    :key="r.id"
                                                >
                                                    <td>{{ r.item_name }}</td>
                                                    <td
                                                        v-if="r.item_sl != null"
                                                    >
                                                        <!--                                                        {{ r.item_sl }}-->
                                                        <barcode
                                                            v-model="r.item_sl"
                                                            width="1"
                                                            height="20"
                                                        >
                                                            ////</barcode
                                                        >
                                                    </td>
                                                    <td
                                                        v-if="r.item_sl == null"
                                                    >
                                                        <!--                                                        {{ r.item_sl }}-->
                                                        <barcode
                                                            v-model="
                                                                r.item_code
                                                            "
                                                            width="1"
                                                            height="20"
                                                        >
                                                            ////</barcode
                                                        >
                                                    </td>
                                                    <td>{{ r.item_charge }}</td>
                                                    <td>{{ r.approved }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <!-- job info summary card end -->

                            <div class="col-lg-12">
                                <div class="row" v-if="history != ''">
                                    <table class="table">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>Date &amp; Time</th>
                                                <th>Job Status</th>
                                                <th>Updated By</th>
                                                <th>Remarks</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="status in history">
                                                <td>
                                                    {{
                                                        status.created_at
                                                            | timeStamp
                                                    }}
                                                </td>
                                                <td>{{ status.status }}</td>
                                                <td>
                                                    {{
                                                        status.updated_by
                                                            .user_detail
                                                    }}
                                                </td>
                                                <td>
                                                    {{ status.remarks }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="col-sm-12">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <h5>Amounts Collected</h5>
                                        <table
                                            class="table table-striped table-bordered table-hover"
                                        >
                                            <thead>
                                                <tr>
                                                    <th>Amount</th>
                                                    <th>Entered By</th>
                                                    <th>Mode</th>
                                                    <th>Remarks</th>
                                                    <th>Transaction ID</th>
                                                    <th>Card No.</th>
                                                    <th>Source Bank</th>
                                                    <th>Destination Bank</th>
                                                    <th>ERP Pushed</th>
                                                    <th>ERP Receipt No.</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="r in payments"
                                                    :key="r.id"
                                                >
                                                    <td>{{ r.amount }}</td>
                                                    <td>
                                                        {{ r.entered_name }}
                                                    </td>
                                                    <td>{{ r.mode }}</td>
                                                    <td>{{ r.remarks }}</td>
                                                    <td>
                                                        {{ r.transaction_id }}
                                                    </td>
                                                    <td>{{ r.card_no }}</td>
                                                    <td>{{ r.source_bank }}</td>
                                                    <td>
                                                        {{
                                                            r.destination_bank_name
                                                        }}
                                                    </td>
                                                    <td
                                                        v-if="r.erp_pushed == 0"
                                                    >
                                                        NO
                                                    </td>
                                                    <td v-else>YES</td>
                                                    <td>
                                                        {{ r.erp_receipt_no }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <br />
                                            <br />
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-12">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="card">
                                            <div
                                                class="card-body overflow-auto"
                                            >
                                                <h5>Job Details</h5>
                                                Job Assigned To:{{
                                                    job.assigned_name
                                                }}
                                                <br />Complaint:{{
                                                    job.complaint
                                                }}
                                                <br />Job Added on:{{
                                                    job.created_at | timeStamp
                                                }}
                                                <br />Job Added By:{{
                                                    job.created_name
                                                }}

                                                <br />Current Condition:{{
                                                    job.current_condition
                                                }}
                                                <br />Expected Delivery Date:{{
                                                    job.expected_delivery_date
                                                        | formattedDateWithOne
                                                }}

                                                <br />Accessories Received:{{
                                                    job.accessories_received
                                                }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="card">
                                            <div
                                                class="card-body overflow-auto"
                                            >
                                                <b>Customer Name:</b>
                                                <h6>{{ job.customer_name }}</h6>
                                                <b>Customer Phone:</b>
                                                <h6>
                                                    {{ job.customer_numbers }}
                                                </h6>
                                                <b>Communication Address:</b>
                                                <h6>{{ job.comm }}</h6>
                                                <b>Billing Address:</b>
                                                <h6>{{ job.bill }}</h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="card">
                                            <div
                                                class="card-body overflow-auto"
                                            >
                                                <h5>Item Details:</h5>
                                                Item Name: {{ job.item_name }}
                                                <br />Item Code:
                                                {{ job.item_code }} <br />Brand:
                                                {{ job.brand }} | Model:
                                                {{ job.model }} <br />Bill
                                                Number: {{ job.bill_number }}
                                                <br />Serial No:
                                                {{ job.sl_no }}
                                                <br />Description:
                                                {{ job.description }}
                                                <br />Type: {{ job.type }} |
                                                Category:
                                                {{ job.category }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <h5>Important Terms to note:</h5>
                                    <p>
                                        1. Oxygen Group, nor its subsidiaries,
                                        nor its employees will be responsible
                                        for any item that isn't collected within
                                        60 days of completion of job sheet.
                                    </p>
                                    <p>
                                        2. We do not provide data preservation
                                        guarantees unless specifically mentioned
                                        in the job sheet description.
                                    </p>
                                </div>
                            </div>
                            <br />
                            <br />
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="col-sm-12">
                                        <p>______________________</p>
                                    </div>
                                    <div class="col-sm-12">
                                        <p>Customer Signature</p>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="col-sm-12">
                                        <p>______________________</p>
                                    </div>
                                    <div class="col-sm-12">
                                        <p>Service Associate Signature</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="break-after: page"></div>
                <!-- row end -->
            </section>
            <!-- /.content -->

            <!-- All VUE Parts end before this comment -->
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        console.log("Component mounted.");
    },

    created() {
        this.getJobDets();
        this.getModes();
        this.getAmounts();
        this.getServiceTerms();
    },

    data() {
        return {
            job: [],
            remarks: [],
            amounts: [],
            form: new Form({
                job_id: "",
                room: "",
                shelf: "",
                rack: "",
                id: "",
            }),
            errors: [],
            payments: [],
            terms: "",
            amount: "",
            history: [],
            modes: [],
            mode: "",
            premark: "",
            transaction_id: "",
        };
    },

    methods: {
        getModes() {
            axios.post("/api/getModes").then((response) => {
                this.modes = response.data;
            });
        },

        print() {
            const prtHtml = document.getElementById("print").innerHTML;

            // Get all stylesheets HTML
            let stylesHtml = "";
            for (const node of [
                ...document.querySelectorAll('link[rel="stylesheet"], style'),
            ]) {
                stylesHtml += node.outerHTML;
            }

            // Open the print window
            const WinPrint = window.open(
                "",
                "",
                "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
            );

            WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`);

            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.print();
            // WinPrint.close();
        },

        getJobDets() {
            axios
                .post("/api/getFullJobDetails", { id: this.$route.params.id })
                .then((response) => {
                    this.job = response.data;
                    this.getRemarks();
                    this.getAmounts();
                    this.getHistory();
                    this.getPayments();
                    if (this.job.status == "Completed") {
                        this.getShelf();
                    }
                });
        },

        getRemarks() {
            axios
                .post("/api/getRemarks", { job: this.job.id })
                .then((response) => {
                    this.remarks = response.data;
                });
        },

        getHistory() {
            axios
                .post("/api/getHistory", { job: this.$route.params.id })
                .then((response) => {
                    this.history = response.data;
                });
        },

        getShelf() {
            axios
                .post("/api/getShelf", { job: this.job.id })
                .then((response) => {
                    this.form.job_id = this.job.id;
                    if (response.data != "") this.form.fill(response.data);
                });
        },

        storeItem() {
            this.form.job_id = this.job.id;
            this.form
                .post("/api/storeJobItem")
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Storage Updated",
                        });
                        this.getShelf();
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                    }
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        getAmounts() {
            axios
                .post("/api/getAmounts", { job: this.job.id })
                .then((response) => {
                    this.amounts = response.data;
                });
        },

        getServiceTerms() {
            axios.post("/api/getLatestServiceTerms").then((response) => {
                this.terms = response.data.terms;
            });
        },

        getPayments() {
            axios
                .post("/api/getPayments", { job: this.job.id })
                .then((response) => {
                    this.payments = response.data;
                });
        },

        addPayment() {
            axios
                .post("/api/addPayment", {
                    job: this.job.id,
                    amount: this.amount,
                    mode: this.mode,
                    remarks: this.premark,
                    transaction_id: this.transaction_id,
                })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Payment Added",
                        });
                        this.getJobDets();
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        printInvoice() {
            this.$router.push("/print/invoice/" + this.response.id);
        },

        deletePayment(id) {
            axios
                .post("/api/deletePayment", { id: id })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Payment Deleted",
                        });
                        this.getJobDets();
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },
    },
};
</script>
